/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { intlShape } from 'react-intl';
import cx from 'classnames';

// import mp from '../../analytic';
import s from './Conditions.css';

class Conditions extends React.Component {
  static propTypes = {
    conditions: PropTypes.object.isRequired,
    hotels: PropTypes.object.isRequired,
  };
  
  static contextTypes = {
    intl: intlShape,
  };
  
  // componentDidMount() {
  //   mp.track('#Terms and Conditions');
  // }

  render() {
    const { conditions, hotels } = this.props;
    const taxes = [];
    const h = [];
    Object.keys(hotels).forEach( key => {
      const {name, tax, local_tax} = hotels[key];
      h.push({
        name, tax, local_tax
      });
    });
    h.sort((h1, h2) => {
      if(h1.name < h2.name) {
        return -1;
      }
      if(h1.name > h2.name) {
        return 1;
      }
      return 0;
    });
    h.forEach( ({name, tax, local_tax}) => {
      taxes.push(<tr>
        <td>{ name }</td>
        <td style={{ textAlign: 'center' }}>{ tax }</td>
        <td style={{ textAlign: 'center' }} dangerouslySetInnerHTML={{__html: local_tax}}/>
      </tr>)
    });
    
    return (
      <div className={cx(s.root, s[this.context.intl.locale])}>
        <div className={s.hero} />
        <div className={s.container} dangerouslySetInnerHTML={{__html: conditions.all}} />
      </div>
    );
  }
}

export default withStyles(s)(Conditions);
